"use client";

import { RouteError, type RouteErrorProps } from "@/components/shell/RouteBoundary";

/**
 * Error boundary for the pre-auth routes (`/login`, `/select-instance`,
 * `/set-password`) — everything outside the `(app)` group (backlog R15).
 */
export default function RootError(props: RouteErrorProps) {
  return <RouteError {...props} />;
}
